import axios from 'axios';
import getAuthorizationUrl from './getAuthorizationUrl';
/*
 * Retrieves Auth Code to generate access token and complete profile creation in IDP Registration flow
 */
const getAuthCode = async ({ baseURL, clientId, redirectURI, loginHintURL, scope, idTokenHint, codeVerifierPrefix }) => {
    try {
        const url = getAuthorizationUrl({
            baseURL,
            clientId,
            redirectURI,
            loginHintURL,
            scope,
            idTokenHint,
            codeVerifierPrefix
        });
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const { request: { responseURL } } = response;
        return responseURL
            ? new URL(responseURL).searchParams.get('code')
            : '';
    }
    catch (error) {
        window.console.error(error);
        return error;
    }
};
export default getAuthCode;
